import { Component, inject, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconService } from './core/services/icon.service';
import { IdleService } from './core/services/idle.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('ComplyDesk');

  private iconService = inject(IconService);
  private idleService = inject(IdleService);

  constructor() {
    this.registerAllIcons();
  }

  ngOnInit(): void {
    this.idleService.startMonitoring();
  }

  private registerAllIcons() {
    this.iconService.registerIcons();
  }
}
